import { jsx as _jsx } from "react/jsx-runtime";
const ChevronUpFilled = () => (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, { children: _jsx("path", { d: "M8 4l4.33 6H3.67L8 4z" }) })));
export default ChevronUpFilled;
